import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/tailwind.css";
import "./styles/index.css";
import {Provider} from "react-redux"
import { PersistGate } from 'redux-persist/es/integration/react'
import Store from '../src/Redux/Store'
import {persistStore} from 'redux-persist'
let persistor = persistStore(Store)
 
const container = document.getElementById("root");
const root = createRoot(container);

root.render(
    <>
        <Provider store={Store}><PersistGate loading={null} persistor={persistor}><App /></PersistGate></Provider>
        </>
);
